/* SUCHE AUF DER FRAGEN-SEITE (02.10.2026, Vorgabe Claras: "fuege bei dem Reiter/der Seite
   Fragen noch eine Suchleiste hinzu, mit der man auf der Fragenseite suchen kann und einem
   dann die Fragen angezeigt werden, die die Frage most likely beantworten").

   GEMEINT IST /pages/wissen-neu, der Reiter "Fragen" in der Navigation - nicht die Vorlage
   page.fragen und nicht der Fragenblock am Seitenende. Nachgesehen, nicht vermutet: Der
   Nav-Eintrag "Fragen" zeigt auf /pages/wissen-neu, und dort steht diese eine Liste mit allen
   75 Fragen. /pages/fragen gibt es im Shop nicht (404).

   SIE FILTERT, STATT EINE ZWEITE LISTE ZU BAUEN. Die Fragen bleiben, wo sie sind - mit ihren
   Nummern, ihren Obertiteln und ihren Sprungmarken, auf die von jeder anderen Seite aus
   verlinkt wird (#F26). Gesucht wird im vorhandenen Markup: Was nicht passt, wird ausgeblendet,
   und die Frage mit der besten Bewertung klappt auf. Eine zweite, erzeugte Trefferliste haette
   jede Frage doppelt ins Dokument gestellt und die id-Marken mehrdeutig gemacht.

   KEIN SERVER, KEINE APP. Alle Fragen stehen ohnehin im HTML - auch die zugeklappten, damit
   Google sie liest. Die Suche braucht deshalb nichts nachzuladen und funktioniert ab dem
   ersten Tastendruck. */
(function(){
  'use strict';

  /* Umlaute ausschreiben statt Akzente strippen: Wer "warmepumpe" tippt, soll "Wärmepumpe"
     finden, und wer "waermepumpe" tippt, ebenfalls. Beide Seiten laufen durch dieselbe
     Funktion, also treffen sie sich in der Mitte. */
  function norm(s){
    var t = String(s||'').toLowerCase()
      .replace(/ä/g,'ae').replace(/ö/g,'oe').replace(/ü/g,'ue').replace(/ß/g,'ss');
    /* Akzente aus Fremdwoertern (Café, Résumé) abstreifen - nur, wo der Browser es kann. */
    if(t.normalize) t = t.normalize('NFD').replace(/[\u0300-\u036f]/g,'');
    /* Alles Uebrige wird zu einem Leerzeichen. Führender und abschliessender Leerraum sind
       weg, deshalb prüft punkte() den Wortanfang mit ' '+wort ODER indexOf(wort)===0. */
    return t.replace(/[^a-z0-9]+/g,' ').trim();
  }

  /* Wörter, die in fast jeder Frage stehen und deshalb nichts aussagen. Sie fliegen nur raus,
     solange danach noch etwas übrig bleibt - wer "was ist das" tippt, bekommt sonst gar keine
     Suche mehr, sondern eine leere Eingabe. */
  var STOPP = ' wie was wann wo wer warum welche welcher welches ist sind war wird werden kann '
            + ' muss soll darf der die das den dem des ein eine einen einem eines und oder aber '
            + ' ich mir mich mein meine wir uns unser ihr euer bei fuer von mit auf aus zum zur '
            + ' im in an es sich nicht noch auch nur man es da dass ob so viel ';
  function begriffe(q){
    var alle = norm(q).split(' ').filter(function(w){ return w.length >= 2; });
    var ohne = alle.filter(function(w){ return STOPP.indexOf(' '+w+' ') < 0; });
    return ohne.length ? ohne : alle;
  }

  /* Bewertung einer Frage gegen die Eingabe.

     Die FRAGE wiegt schwerer als die Antwort: Wer "Lautstärke" sucht, will die Frage nach der
     Lautstärke und nicht die Frage nach der Aufstellung, in deren Antwort das Wort einmal
     vorkommt. Ein Wortanfang wiegt schwerer als ein Treffer irgendwo in der Mitte.

     JEDES SUCHWORT TRÄGT EIN EIGENES GEWICHT (siehe gewichte()). Ohne das gewann bei "wie laut
     ist die Wärmepumpe" die Bauart-Frage: "wärmepumpe" steht in vierzig Fragen und sammelte
     vierzig Mal zehn Punkte, "laut" in zweien. Gesucht wird aber nach dem seltenen Wort - es
     ist das, was die Frage von allen anderen unterscheidet. */
  function punkte(eintrag, worte, phrase){
    var p = 0, getroffen = 0, i, w, g, hier;
    for(i=0;i<worte.length;i++){
      w = worte[i].w; g = worte[i].g; hier = 0;
      if(eintrag.frage.indexOf(' '+w) >= 0 || eintrag.frage.indexOf(w) === 0) hier += 10 * g;
      else if(eintrag.frage.indexOf(w) >= 0) hier += 6 * g;
      if(eintrag.antwort.indexOf(' '+w) >= 0 || eintrag.antwort.indexOf(w) === 0) hier += 3 * g;
      else if(eintrag.antwort.indexOf(w) >= 0) hier += 2 * g;
      if(eintrag.sektion.indexOf(w) >= 0) hier += 2 * g;
      /* Die Nummer selbst ist eine gültige Suche: "F12" führt direkt zu F12. */
      if(eintrag.idx && eintrag.idx === w) hier += 60;
      if(hier > 0) getroffen++;
      p += hier;
    }
    if(!p) return 0;
    /* ABDECKUNG (02.10.2026). Eine Frage, in der ALLE Suchwörter vorkommen, gehört vor eine, in
       der nur das häufigste steht. Ohne diesen Faktor gewann bei "wie laut ist die Wärmepumpe"
       jede beliebige Wärmepumpen-Frage gegen die, die tatsächlich von der Lautstärke handelt:
       Ein Treffer in der Frage wiegt mehr als einer in der Antwort, und das kippte die
       Reihenfolge, obwohl die eine beide Wörter hat und die andere nur eins. */
    p *= 0.5 + 0.5 * (getroffen / worte.length);
    /* Die ganze Eingabe als zusammenhängender Satzteil in der Frage - das ist der stärkste
       Hinweis darauf, dass genau diese Frage gemeint war. */
    if(phrase.length > 4 && eintrag.frage.indexOf(phrase) >= 0) p += 14;
    return p;
  }

  function init(){
    var feld = document.getElementById('faqSuche');
    if(!feld) return;
    var wurzel = feld.closest('section') || document;
    var fragen = [].slice.call(wurzel.querySelectorAll('details.faq'));
    /* Ohne Fragen keine Suche: Liegt ein App-Block in der Section, kommt der Inhalt von dort
       und dieses Markup gibt es nicht. Dann verschwindet auch die Leiste - ein Suchfeld, das
       nichts durchsuchen kann, ist ein Versprechen auf nichts. */
    var leiste = feld.closest('.faq-suche');
    if(!fragen.length){ if(leiste) leiste.hidden = true; return; }

    var zaehler = document.getElementById('faqSucheInfo');
    var loeschen = document.getElementById('faqSucheWeg');

    /* DIE OBERTITEL SIND GESCHWISTER DER FRAGEN, keine Container: Die Liste ist flach, und
       eine Überschrift gilt für alles, was bis zur nächsten Überschrift folgt. Deshalb wird die
       Zuordnung hier einmal über die Reihenfolge gebildet - closest() hätte nichts gefunden,
       und ohne Zuordnung bliebe beim Filtern eine Überschrift über null Fragen stehen. */
    var gruppen = [].slice.call(wurzel.querySelectorAll('.wf-obertitel'));
    var gruppeVon = (function(){
      var zuordnung = [], lauf = null;
      [].slice.call(wurzel.querySelectorAll('.wf-obertitel, details.faq')).forEach(function(k){
        if(k.classList.contains('wf-obertitel')) lauf = k;
        else zuordnung.push([k, lauf]);
      });
      return function(el){
        for(var i=0;i<zuordnung.length;i++){ if(zuordnung[i][0] === el) return zuordnung[i][1]; }
        return null;
      };
    })();

    var daten = fragen.map(function(el){
      var frageEl = el.querySelector('.fq');
      var idxEl = el.querySelector('.fidx');
      var antwortEl = el.querySelector('p');
      var gruppe = gruppeVon(el);
      var sekEl = gruppe;
      return {
        el: el,
        gruppe: gruppe,
        warOffen: el.open,
        frage: norm(frageEl ? frageEl.textContent : ''),
        /* Nur der Antworttext, nicht el.textContent: Darin steckt die Frage noch einmal, und
           sie wuerde doppelt zaehlen - einmal mit Fragen- und einmal mit Antwortgewicht. */
        antwort: norm(antwortEl ? antwortEl.textContent : ''),
        sektion: norm(sekEl ? sekEl.textContent : ''),
        idx: norm(idxEl ? idxEl.textContent : '')
      };
    });

    /* Der Wortschatz der ganzen Liste - gebraucht, um zusammengesetzte Suchwörter zu zerlegen
       (siehe zerlegen). Einmal beim Laden gebildet, nicht bei jedem Tastendruck. */
    var vokabular = {};
    daten.forEach(function(d){
      (d.frage + ' ' + d.antwort).split(' ').forEach(function(w){
        if(w.length >= 4) vokabular[w] = 1;
      });
    });
    var vokabelliste = Object.keys(vokabular).sort(function(a,b){ return b.length - a.length; });

    /* In wie vielen Fragen kommt ein Wort vor? */
    function haeufigkeit(w){
      var n = 0;
      for(var i=0;i<daten.length;i++){
        /* Die Nummer zählt mit, sonst fiele "F26" als unbekanntes Wort aus der Suche heraus,
           bevor punkte() es überhaupt mit einer Nummer vergleichen kann. */
        if(daten[i].frage.indexOf(w) >= 0 || daten[i].antwort.indexOf(w) >= 0 || daten[i].idx === w) n++;
      }
      return n;
    }

    /* DEUTSCHE KOMPOSITA (02.10.2026). "Stromverbrauch" steht in keiner Frage - "Strom" und
       "Verbrauch" schon, jeweils für sich. Ohne diesen Schritt antwortete die Suche auf ein
       sehr konkretes Wort mit "keine Frage passt", obwohl die Antwort dasteht.

       Gesucht werden die längsten bekannten Wörter, die in dem Suchwort stecken; höchstens
       zwei, sonst zerfällt ein Wort in lauter Silben, die überall vorkommen. Sie zählen nur
       halb: Ein Teiltreffer ist ein Hinweis, kein Beweis. */
    function zerlegen(w){
      if(w.length < 8) return [];
      var teile = [], i, v;
      for(i=0;i<vokabelliste.length && teile.length<2;i++){
        v = vokabelliste[i];
        if(v.length >= 4 && v.length < w.length && w.indexOf(v) >= 0){
          /* Keine zwei Teile, die einander überlappen - "verbrauch" und "erbrauch" wären
             zweimal dasselbe. */
          if(!teile.some(function(t){ return v.indexOf(t) >= 0 || t.indexOf(v) >= 0; })) teile.push(v);
        }
      }
      return teile;
    }

    /* GEWICHT JE SUCHWORT. Ein Wort, das in fast jeder Frage steht, sagt fast nichts; eines,
       das in zweien steht, sagt fast alles. Der Logarithmus dämpft das, damit ein seltenes
       Wort das Feld nicht allein bestimmt - gesucht wird ja nach allen Wörtern zusammen.
       Das Ergebnis liegt zwischen gut 0,1 (steht überall) und 1 (steht genau einmal). */
    function gewichte(worte){
      var n = daten.length, teiler = Math.log(1 + n), raus = [];
      worte.forEach(function(w){
        var h = haeufigkeit(w);
        if(h > 0){
          raus.push({w:w, g: Math.log(1 + n / h) / teiler});
          return;
        }
        /* Kommt gar nicht vor: in seine bekannten Bestandteile zerlegen. */
        zerlegen(w).forEach(function(t){
          var ht = haeufigkeit(t);
          if(ht > 0) raus.push({w:t, g: 0.5 * Math.log(1 + n / ht) / teiler});
        });
      });
      return raus;
    }

    function zuruecksetzen(){
      daten.forEach(function(d){
        d.el.hidden = false;
        d.el.classList.remove('faq-top');
        d.el.open = d.warOffen;
      });
      gruppen.forEach(function(g){ g.hidden = false; });
      if(zaehler){ zaehler.textContent = ''; zaehler.hidden = true; }
    }

    /* Höchstens so viele Treffer - sonst beantwortet ein einzelnes Wort wie "Förderung" die
       Suche mit der halben Seite, und das ist dasselbe wie keine Antwort. Gezeigt wird die
       beste Auswahl, aber in der Reihenfolge der Seite: Die Nummern laufen dann weiter
       aufwärts, und wer die Liste kennt, findet sich darin wieder. */
    var MAX = 10;

    function suchen(){
      var q = feld.value.trim();
      if(q.length < 2){ zuruecksetzen(); return; }
      var worte = gewichte(begriffe(q)), phrase = norm(q);
      if(!worte.length){
        zuruecksetzen();
        if(zaehler){
          zaehler.hidden = false;
          zaehler.textContent = 'Zu „' + q + '“ passt keine Frage. Schau in den Gruppen unten nach – oder frag uns einfach direkt.';
        }
        return;
      }

      var bewertet = daten.map(function(d){ return {d:d, p:punkte(d, worte, phrase)}; })
                          .filter(function(x){ return x.p > 0; })
                          .sort(function(a,b){ return b.p - a.p; });

      if(!bewertet.length){
        /* Nichts gefunden: Die Seite bleibt vollständig stehen statt leer zu werden. Wer
           nichts findet, braucht die Liste zum Durchsehen - nicht ihre Abwesenheit. */
        zuruecksetzen();
        if(zaehler){
          zaehler.hidden = false;
          zaehler.textContent = 'Zu „' + q + '“ passt keine Frage. Schau in den Gruppen unten nach – oder frag uns einfach direkt.';
        }
        return;
      }

      /* Schwach bewertete Treffer fallen weg, gemessen AM BESTEN: Bei einem klaren Treffer
         soll nicht der halbe Rest mitkommen, nur weil irgendwo dasselbe Wort steht.

         Rein relativ und ohne festen Mindestwert. Hier stand bis zum 02.10.2026 ein
         Math.max(..., 2) - ein Rest aus der Zeit vor der Gewichtung, als die Punkte um den
         Faktor drei größer waren. Danach lagen ganze Suchen ("Stromverbrauch",
         "Heizkörper tauschen") unter der Schwelle und meldeten "keine Frage passt", obwohl
         die Treffer da waren und die Reihenfolge stimmte. */
      var grenze = bewertet[0].p * 0.34;

      /* WIE SICHER IST DER BESTE TREFFER? Unterhalb dieser Punktzahl sind alle Treffer nur noch
         Fundstellen eines Wortes irgendwo in einer Antwort - "laut" steht in der Frage zum
         Kälteschein, aber als Präposition ("laut Verordnung"), nicht als Lautstärke. So etwas
         aufzuklappen und als Antwort hinzustellen, wäre eine Behauptung, die die Suche nicht
         decken kann. Dann werden die Fundstellen gezeigt und als das benannt, was sie sind. */
      var sicher = bewertet[0].p >= 5;
      var treffer = bewertet.filter(function(x){ return x.p >= grenze; }).slice(0, sicher ? MAX : 5);
      var drin = treffer.map(function(x){ return x.d; });
      var bester = sicher ? treffer[0].d : null;

      daten.forEach(function(d){
        var zeigen = drin.indexOf(d) >= 0;
        d.el.hidden = !zeigen;
        d.el.classList.toggle('faq-top', zeigen && d === bester);
        /* Der beste Treffer steht offen - das ist die Antwort, nach der gesucht wurde. Die
           übrigen bleiben zu, damit die Trefferliste als Liste lesbar bleibt. */
        d.el.open = zeigen && d === bester;
      });
      /* Eine Überschrift bleibt nur stehen, wenn unter ihr noch eine Frage steht. */
      gruppen.forEach(function(g){
        g.hidden = !drin.some(function(d){ return d.gruppe === g; });
      });

      if(zaehler){
        zaehler.hidden = false;
        if(!sicher){
          zaehler.textContent = 'Nichts passt genau zu „' + q + '“. Am nächsten kommen diese – oder frag uns einfach direkt.';
        } else {
          zaehler.textContent = treffer.length === 1
            ? 'Eine Frage passt zu „' + q + '“ – sie steht offen.'
            : treffer.length + ' Fragen passen zu „' + q + '“ – die oberste am ehesten.';
        }
      }
    }

    feld.addEventListener('input', suchen);
    /* Enter darf das umgebende Formular nicht abschicken - gesucht wird ohnehin bei jedem
       Zeichen, ein Absenden würde die Seite nur neu laden und die Eingabe verlieren. */
    feld.addEventListener('keydown', function(e){
      if(e.key === 'Enter'){ e.preventDefault(); suchen(); }
      if(e.key === 'Escape'){ feld.value = ''; zuruecksetzen(); }
    });
    if(loeschen) loeschen.addEventListener('click', function(){
      feld.value = ''; zuruecksetzen(); feld.focus();
    });

    /* ?q=... in der Adresse sucht sofort - damit sich ein Treffer verlinken lässt, etwa aus
       einer Antwort des Chats oder einer Mail heraus. */
    try{
      var vorgabe = new URLSearchParams(location.search).get('q');
      if(vorgabe){ feld.value = vorgabe; suchen(); }
    }catch(e){}
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
